module.exports = __webpack_public_path__ + "img/box_report.a921c766.png";